import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import api from '../utils/functions/api';

const SocketContext = createContext(null);

export const useSocket = () => useContext(SocketContext);

export default function SocketProvider({ children }) {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    // Connect to backend — same origin in production, REACT_APP_API_URL in dev
    const apiUrl = (process.env.REACT_APP_API_URL || '').trim();
    // Extract base URL (remove /api/v1 or /api/v2 suffix)
    const baseUrl = apiUrl.replace(/\/api\/v\d+$/, '').trim();

    console.log('[Socket.IO] Connecting to:', baseUrl || '(same origin)');

    const newSocket = io(baseUrl || undefined, {
      transports: ['websocket', 'polling'],
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      timeout: 10000,
    });

    newSocket.on('connect', () => {
      console.log('[Socket.IO] ✅ Connected:', newSocket.id);
    });

    newSocket.on('disconnect', (reason) => {
      console.log('[Socket.IO] ❌ Disconnected:', reason);
    });

    newSocket.on('connect_error', (err) => {
      console.warn('[Socket.IO] ⚠️ Connection error:', err.message);
    });

    // Listen for any event for debugging
    newSocket.onAny((event, ...args) => {
      console.log('[Socket.IO] 📩 Event:', event, args);
    });

    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, []);

  // Heartbeat ping ทุก 2 นาที — บอก backend ว่า user ยังเปิด tab อยู่
  useEffect(() => {
    const ping = () => {
      const token = localStorage.getItem('token');
      if (!token) return;
      api.post(`${process.env.REACT_APP_API_URL}/user/ping`).catch(() => {});
    };
    ping(); // ping ทันทีที่ mount
    const id = setInterval(ping, 2 * 60 * 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
}
